<template>
    <section class="mx-auto max-w-7xl px-6 lg:px-8 pt-16 sm:pt-40">
        <div class="mx-auto max-w-2xl text-center">
            <h2 class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                {{ t('pages.home.steps.title') }}
            </h2>
            <p class="mt-6 text-lg leading-8 text-white/50">
                {{ t('pages.home.steps.subtitle') }}
            </p>
        </div>

        <div class="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-12 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            <StepCard stepNumber="1" :title="t('pages.home.steps.items.upload')" imgSrc="/idx/face_swap_step_01.jpg" />
            <StepCard stepNumber="2" :title="t('pages.home.steps.items.target')" imgSrc="/idx/face_swap_step_02.jpg" />
            <StepCard stepNumber="3" :title="t('pages.home.steps.items.swap')" imgSrc="/idx/face_swap_step_03.jpg" />
        </div>
        <div class="mt-12 w-full flex justify-center">
            <FaceSwapBtn />
        </div>
    </section>
</template>

<script setup lang="ts">
import FaceSwapBtn from '~/components/FaceSwapBtn.vue';
import StepCard from './StepCard.vue';

const { t } = useI18n();
</script>
